import React from 'react'

export default ({ id, className, children }) => (
  <section className={'section ' + (className || '')} id={id}>
    <div className="container">{children}</div>
  </section>
)
